import React from 'react';
import getCMSAnalyticsTags from '../../analytics/get-cms-analytics-tags';
import { warn } from '../../utils/error-logging';
import { progressiveGridSizing } from '../../utils/gridUtils';
import { useConfig } from '../../config/ContentComponentLibraryProvider';
import ErrorBoundary from '../../components/ErrorBoundary';
const CmsComponent = ({ component, position, index, preloadImages = false }) => {
    const config = useConfig();
    if (!component) {
        return null;
    }
    const componentDetails = config.componentMap.get(component === null || component === void 0 ? void 0 : component.resourceType);
    if (!componentDetails || !componentDetails.component) {
        warn(`No mapped component for resource type: ${component.resourceType}`, {
            logger: 'aem',
            section: 'CmsComponent',
            extra: {
                resourceType: component.resourceType,
                componentId: component.componentId,
            },
        });
        return null;
    }
    const { component: Component, analyticsName } = componentDetails;
    const analyticsTags = analyticsName && component.analytics
        ? getCMSAnalyticsTags(component.componentId, component.analytics, analyticsName, position)
        : undefined;
    let cqResponsiveClasses;
    try {
        cqResponsiveClasses = progressiveGridSizing([], component.cqResponsive, 12, true);
    }
    catch (err) {
        cqResponsiveClasses = [];
    }
    const cqResponsiveClassesWithBodge = [
        'aem-grid-blocker-class',
        ...cqResponsiveClasses,
    ];
    const componentProperties = Object.assign(Object.assign({}, component), { analyticsTags, cqResponsiveClasses: cqResponsiveClassesWithBodge, position,
        index,
        preloadImages });
    return (React.createElement(ErrorBoundary, { section: "CmsComponent", onError: config.onError },
        React.createElement(Component, Object.assign({}, componentProperties))));
};
export default CmsComponent;
//# sourceMappingURL=index.js.map